import * as validator from 'validator';

const PHONE_REGEXP = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{1,6}$/im;

const ONLY_NUMBERS_LETTERS_DASH = /^[a-zA-Z|0-9|-]*$/;

const EXTENSIONS_REGEXP = (ext) => new RegExp(`[\\/.](${ext.join('|')})`, 'i');

const DEFAULT_IMAGE_EXTENSIONS = ['gif', 'jpg', 'jpeg', 'tiff', 'png'];

const DEFAULT_DECIMAL_OPTIONS = {
  force_decimal: true,
  decimal_digits: '2',
  locale: 'en-US',
};

const DEFAULT_PASSWORD_OPTIONS = {
  minLength: 8,
  minLowercase: 1,
  minUppercase: 0,
  minNumbers: 1,
  minSymbols: 1,
  returnScore: false,
};

export default function useValidator() {
  const isOnlyNumbersLettersDash = (val) => {
    if (!val) return false;
    return ONLY_NUMBERS_LETTERS_DASH.test(val);
  };

  const isEmail = (val) => {
    if (!val) return false;
    return validator.isEmail(val);
  };

  const isPhone = (val) => {
    if (!val) return false;
    return PHONE_REGEXP.test(val);
  };

  const isInt = (val, options = {}) => {
    if (!val && val !== 0) return false;
    return validator.isInt(`${val}`, options);
  };

  const isDecimal = (val, options = {}) => {
    const { min, max } = options;
    if (!val && val !== 0) return false;
    if ((Number.isFinite(min) && val < min) || (Number.isFinite(max) && val > max)) return false;
    const opt = {
      ...DEFAULT_DECIMAL_OPTIONS,
      ...options,
    };
    return validator.isDecimal(`${val}`, opt);
  };

  const isPassword = (val, options = {}) => {
    if (!val) return false;
    const opt = {
      ...DEFAULT_PASSWORD_OPTIONS,
      ...options,
    };
    return validator.isStrongPassword(val, opt);
  };

  const isValidExtension = (val, ext = []) => {
    if (!val) return false;
    return val.match(EXTENSIONS_REGEXP(ext));
  };

  const isValidNumber = (val) => val !== undefined && val !== null && Number.isFinite(Number(val));

  const isImage = (val, ext = DEFAULT_IMAGE_EXTENSIONS) => isValidExtension(val, ext);

  const isValidURL = (path, options = {}) => validator.isURL(path, options);

  return {
    isDecimal,
    isEmail,
    isImage,
    isInt,
    isOnlyNumbersLettersDash,
    isPassword,
    isPhone,
    isValidExtension,
    isValidNumber,
    isValidURL,
  };
}
